/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import type { TypeDisplayErrors } from 'forms/validation/Validator';
import styles from 'views/ActionDrawer/ActionDrawer.module.scss';
import type Form from 'forms/_.extend';

import AutoCompleteModel from 'models/forms/AutoCompleteModel.js';
import { autoCompleteCountries } from 'api/forms.js';

type TypeProps = {
  project: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewBuildingForm extends React.Component<*> {
  // constructor(props: Object) {
  //     super(props);
  //     this.props.accountsModel.clear();
  //     this.props.companyModel.clear();
  //     this.props.companyModel.filterId = this.props.form.$('addSiteForm.tradingAccount').value;
  // }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const form: Form = this.props.form;
    const parentForm: Object = this.props.parentForm;

    const countryModel: AutoCompleteModel = new AutoCompleteModel(autoCompleteCountries);
    countryModel.filterId = parentForm.$('location.locationCompany').extra.selectID;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock divider={false} gutters={true}>
            <div className={styles['form-group']}>
              <ElectroTextField field={form.$('addBuildingForm.companyName')} />
              <ElectroTextField field={form.$('addBuildingForm.site')} />
              <ElectroTextField field={form.$('addBuildingForm.buildingName')} />
              <ElectroTextField field={form.$('addBuildingForm.contactPhoneNo')} />
              <ElectroTextField field={form.$('addBuildingForm.contactFaxNo')} />
              <ElectroTextField field={form.$('addBuildingForm.locationContact')} />
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.create')} />
      </React.Fragment>
    );
  }
}
